<!--
 * @Author: your name
 * @Date: 2021-05-20 11:07:43
 * @LastEditTime: 2021-06-04 10:54:28
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \VtpWechatUI\src\components\HelloWorld.vue
-->
<template>
  <div :model="model" style="background:#FAFAFA">
    <!-- <div class="weui-cells__title" style="font-weight:bold;font-size:110%;background-color: transparent;">入园申请</div> -->
    <!-- <div class="link-top" tyle="width: 50%;height: 1px;border-top: solid #ACC0D8 1px;"></div> -->
    <div class="weui-cells__title TitleClass" align="center">被访人信息</div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell" align="left">
        <div class="weui-cell__hd" style="width:20%">
          <label class="weui-label" prop="visitedname" style="float:left">姓名：<span style="color:red">*</span></label>
        </div>
        <div class="weui-cell__bd" style="float:right">
          <input v-model="model.visitedname" class="weui-input" type="text" required="required">
        </div>
      </div>
      <div class="weui-cell lineHeng">
      </div>
    </div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd" style="width:20%">
          <label class="weui-label" align="left" prop="visitedphonenum">电话：<span style="color:red">*</span></label>
        </div>
        <div class="weui-cell__bd">
          <input v-model="model.visitedphonenum" class="weui-input" type="number"
            @change="visitedphonenumChange($event)" placeholder="">
        </div>
      </div>
      <div class="weui-cell lineHeng">
      </div>
    </div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd" style="width:20%">
          <label class="weui-label" align="left" prop="visiteddeptfullname">部门：</label>
        </div>
        <div class="weui-cell__bd">
          <input v-model="model.visiteddeptfullname" class="weui-input" type="text" style="font-size:12px" disabled
            placeholder="正确填写手机号后自动填充">
        </div>
      </div>
      <div class="weui-cell lineHeng">
      </div>
    </div>
    <div class="weui-cells__title TitleClass" align="center">访客信息</div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd" style="width:20%"><label class="weui-label" align="left">姓名：<span
              style="color:red">*</span></label></div>
        <div class="weui-cell__bd">
          <input v-model="model.visitorname" class="weui-input" type="text" placeholder="">
        </div>
      </div>
      <div class="weui-cell lineHeng">
      </div>
    </div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd" style="width:20%"><label class="weui-label" align="left">电话：<span
              style="color:red">*</span></label></div>
        <div class="weui-cell__bd">
          <input v-model="model.visitorphonenum" class="weui-input" type="number" placeholder="">
        </div>
      </div>
      <div class="weui-cell lineHeng">
      </div>
    </div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd"><label class="weui-label" align="left">身份证号：<span style="color:red">*</span></label>
        </div>
        <div class="weui-cell__bd">
          <input v-model="model.visitoridcard" class="weui-input" type="text" placeholder="">
        </div>
      </div>
      <div class="weui-cell lineHeng">
      </div>
    </div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd"><label class="weui-label" align="left">所属单位：<span style="color:red">*</span></label>
        </div>
        <div class="weui-cell__bd">
          <input v-model="model.visitorcompony" class="weui-input" type="text" placeholder="">
          <!-- <van-datetime-picker v-model="currentDate" type="datetime" title="选择完整时间" :min-date="minDate" :max-date="maxDate" /> -->
        </div>
      </div>
      <div class="weui-cell lineHeng">
      </div>
    </div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd"><label class="weui-label" align="left">入园时间：<span style="color:red">*</span></label>
        </div>
        <div class="weui-cell__bd">
          <input v-model="model.estimateintoparktime" @focus="showpopup(1)" placeholder="时间格式2020-01-01 00:00"
            style="border:none;width:100%" type="primary" />
          <van-popup v-model="show" position="bottom">
            <van-datetime-picker type="datetime" :min-date="minDate" :filter="vanDatetimePickerFilter"
              @confirm="saveTimeAction" @cancel="show= false" />
          </van-popup>
        </div>
      </div>
      <div class="weui-cell lineHeng">
      </div>
    </div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd"><label class="weui-label" align="left">离园时间：<span style="color:red">*</span></label>
        </div>
        <div class="weui-cell__bd">
          <input v-model="model.estimateleavetime" @focus="showpopup(2)" placeholder="时间格式2020-01-01 00:00"
            style="border:none;width:100%" type="primary" />
          <van-popup v-model="show1" safe-area-inset-bottom position="bottom">
            <van-datetime-picker type="datetime" :min-date="minDate" :filter="vanDatetimePickerFilter"
              @confirm="saveTimeEnd" @cancel="show1=false" />
          </van-popup>
        </div>
      </div>
      <div class="weui-cell lineHeng">
      </div>
    </div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd"><label class="weui-label" align="left">来访事由：<span style="color:red">*</span></label>
        </div>
        <div class="weui-cell__bd">
          <input v-model="model.visitreason" class="weui-input" type="text" placeholder="">
        </div>
      </div>
      <div class="weui-cell lineHeng">
      </div>
    </div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd" style="width:20%"><label class="weui-label" align="left">车牌号：</label></div>
        <div class="weui-cell__bd">
          <input v-model="model.carnumber" class="weui-input" type="text" placeholder="如果录入，则只能从北门开车进出！">
        </div>
      </div>
      <div class="weui-cell lineHeng">
      </div>
    </div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd"><label class="weui-label" align="left" style="width: 190px;">是否携带鼎信产品：</label>
      </div>
        <van-radio-group v-model="model.iscarry" @change="isCarry">
          <van-radio class="radio-iscarry" name="1">是</van-radio>&nbsp;&nbsp;&nbsp;&nbsp;
          <van-radio class="radio-iscarry" name="0">否</van-radio>
        </van-radio-group>
      </div>
    </div>
    <div class="weui-cells weui-cells_form" v-if="showProduct">
      <div class="weui-cell">
        <div class="weui-cell__hd"><label class="weui-label" align="left">产品明细：<span style="color:red">*</span></label>
        </div>
        <div class="weui-cell__bd">
          <input v-model="model.productname" class="weui-input" type="text" placeholder="">
        </div>
      </div>
      <div class="weui-cell lineHeng">
      </div>
    </div>
    <!-- 附件 -->
    <div class="weui-cells weui-cells_form" id="uploader" v-show="showCode">
      <div class="weui-cell">
        <div class="weui-cell__bd">
          <div class="weui-uploader">
            <div class="weui-uploader__hd">
              <p class="weui-uploader__title">图片上传（含健康码、行程码；如14天内途径疫情中、高风险区，还需上传核酸检测报告）：<span style="color:red">*</span>
              </p>
              <div class="weui-uploader__info"><span id="uploadCount">0</span>/20</div>
            </div>
            <div class="weui-uploader__bd">
              <ul class="weui-uploader__files" id="uploaderFiles"></ul>
              <div class="weui-uploader__input-box">
                <input name="file" id="uploaderInput" class="weui-uploader__input" type="file" accept="image/*"
                  multiple="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="weui-cells__title TitleClass" align="center">同行者信息</div>
    <div>
      <div v-for="(list,index) in lists" :key="list.index">
        <div class="weui-cells weui-cells_form">
          <div class="weui-cell">
            <div class="weui-cell__hd" style="width:20%">
              <label class="weui-label" align="left">姓名：<span style="color:red">*</span></label>
            </div>
            <div class="weui-cell__bd">
              <input v-model="list.visitorname" class="weui-input" type="text" placeholder="" sytle="width:75%">
            </div>
            <span>
              <van-button @click="del(index)" plain type="info" style="border:none;color:#169BD5">删除</van-button>
            </span>
          </div>
          <div class="weui-cell lineHeng">
          </div>
        </div>
        <div class="weui-cells weui-cells_form">
          <div class="weui-cell">
            <div class="weui-cell__hd" style="width:20%"><label class="weui-label" align="left">电话：<span
                  style="color:red">*</span></label></div>
            <div class="weui-cell__bd">
              <input v-model="list.visitorphonenum" class="weui-input" type="number" placeholder="">
            </div>
          </div>
          <div class="weui-cell lineHeng">
          </div>
        </div>
        <div class="weui-cells weui-cells_form">
          <div class="weui-cell">
            <div class="weui-cell__hd"><label class="weui-label" align="left">身份证号：<span
                  style="color:red">*</span></label></div>
            <div class="weui-cell__bd">
              <input v-model="list.visitoridcard" class="weui-input" type="text" placeholder="">
            </div>
          </div>
          <div class="weui-cell lineHeng">
          </div>
        </div>
      </div>
      <div class="weui-cells weui-cells_form" align="center">
        <!--
                 <img src="static\add.png" style="width:20px">
-->
        <div class="weui-cell" align="center" :style="{'background-color':addPartnerBackGroundColor}"><label
            class="weui-label" align="center" style="width:100%;color:#169BD5;border:none;"
            @click="addPartner">&nbsp;+&nbsp;增加同行者</label></div>
      </div>
    </div>
    <div class="weui-btn-area">
      <button class="weui-btn weui-btn_primary" @click="enterpark(model)"
        style="background-color: #169BD5;color:#FFFFFF">提交</button>
    </div>
  </div>
</template>

<script>
import weui from '../../static/plugins/weui.min.js'
import { getAction, postAction } from '../request/http'
import { Toast } from 'we-vue'
import $ from 'jquery'
var uploadCount = 0
var uploadCountDom = null
var uploadList = []
var sourceid
var attachmenttypeid
var docno
var visitorname
export default {
  name: 'HelloWorld',
  data() {
    return {
      show: false,
      show1: false,
      showCode: false,
      showProduct: false,
      minDate: new Date(),
      model: {
        iscarry: '0'
      },
      screenWidth: document.body.clientWidth, // 屏幕宽
      datalist: [],
      lists: [],
      addPartnerBackGroundColor: 'white',
      pageInfo: {
        currentPage: 1, // 当前页面
        pageSize: 10,
        totalCount: 0, // 总数
        sord: 'desc',
        sidx: 'id'
      }
    }
  },
  computed: {},
  beforeCreate() {
    document.title = '入园申请'
  },
  created() {},
  mounted() {
    var that = this
    // 附件上传
    uploadCountDom = document.getElementById('uploadCount')
    weui.uploader('#uploader', {
      url: process.env.BASE_API + '/vtp/toaEnterParkApply/upload',
      // url: 'http://172.20.193.147:7000/vtp/toaEnterParkApply/upload',
      auto: false,
      type: 'file',
      fileVal: 'file',
      compress: {
        width: 1600,
        height: 1600,
        quality: 0.8
      },
      // 文件添加前的回调
      onBeforeQueued: function(files) {
        // `this` 是轮询到的文件, `files` 是所有文件
        if (['image/jpg', 'image/jpeg', 'image/png', 'image/gif'].indexOf(this.type) < 0) {
          weui.alert('请上传图片')
          return false // 阻止文件添加
        }
        if (this.size > 10 * 1024 * 1024) {
          weui.alert('请上传不超过10M的图片')
          return false
        }
        if (files.length > 10) {
          // 防止一下子选择过多文件
          weui.alert('一次最多只能上传10张图片，请重新选择')
          return false
        }
        if (uploadCount + 1 > 20) {
          weui.alert('最多只能上传20张图片')
          return false
        }
        if (that.model.visitorname === '' || that.model.visitorname === undefined) {
          that.$weui.confirm('请先填写完整个人信息！', {
            title: '信息不完整：',
            buttons: [
              {
                label: '确定',
                type: 'primary',
                onClick: function() {}
              }
            ]
          })
          this.stop
          return false
        } else {
          visitorname = that.model.visitorname
        }
        ++uploadCount
        uploadCountDom.innerHTML = uploadCount
        // return true; // 阻止默认行为，不插入预览图的框架
      },
      // 文件添加成功的回调
      onQueued: function() {
        uploadList.push(this)
        this.upload() // 如果是手动上传，这里可以通过调用upload来实现；也可以用它来实现重传。
      },
      // 文件上传前调用
      onBeforeSend: function(data, headers) {
        // console.log(this)
        if (that.sourceid === undefined) {
          that.sourceid = ''
          that.attachmenttypeid = ''
        }
        // console.log(headers)
        $.extend(data, {
          sourceid: that.sourceid,
          attachmenttypeid: that.attachmenttypeid,
          visitorname: visitorname,
          id: this.id
        }) // 可以扩展此对象来控制上传参数
      },
      // 上传进度的回调
      onProgress: function(procent) {},
      // 上传成功的回调
      onSuccess: function(ret) {
        // console.log(ret)
        if (ret.status === 'true') {
          if (ret.docno !== null) {
            that.docno = ret.docno
          }
          that.sourceid = ret.sourceid
          that.attachmenttypeid = ret.attachmenttypeid
          return true
        } else {
          Toast.fail(ret.msg)
          return false
        }
      },
      // 上传失败的回调
      onError: function(err) {
        // console.log(this, err)
      }
    })
    // weui.gallery图片预览功能
    document.querySelector('#uploaderFiles').addEventListener('click', function(e) {
      var target = e.target
      while (!target.classList.contains('weui-uploader__file') && target) {
        target = target.parentNode
      }
      if (!target) return
      var url = target.getAttribute('style') || ''
      var id = target.getAttribute('data-id')
      if (url) {
        url = url.match(/url\((.*?)\)/)[1].replace(/"/g, '')
      }
      var gallery = weui.gallery(url, {
        className: 'custom-name',
        onDelete: function onDelete() {
          weui.confirm('确定删除该图片？', function() {
            --uploadCount
            uploadCountDom.innerHTML = uploadCount
            for (var i = 0, len = uploadList.length; i < len; ++i) {
              var file = uploadList[i]
              var tempId = file.id
              if (String(tempId) === id) {
                that.deleteFile(id, that.sourceid, visitorname)
                file.stop()
                break
              }
            }
            target.remove()
            gallery.hide()
          })
        }
      })
    })
    this.createmore()
  },
  methods: {
    deleteFile(index, sourceid, visitorname) {
      postAction('/vtp/toaEnterParkApply/deleteFile', {
        index: index,
        sourceid: sourceid,
        visitorname: visitorname
      }).then(res => {
        let success = res.data.success
        if (success) {
          Toast.success('删除成功')
        } else {
          Toast.fail('删除失败')
        }
      })
    },
    vanDatetimePickerFilter(type, options) {
      if (type === 'minute') {
        return options.filter(option => option % 10 === 0)
      }
      return options
    },
    visitedphonenumChange() {
      getAction('/vtp/toaEnterParkApply/getUserDeptFullNameByMobile', { qry_mobile: this.model.visitedphonenum }).then(
        res => {
          let msg = res.data.result.result
          if (msg === undefined || msg.length === 0) {
            this.model.visiteddeptfullname = ''
            Toast.fail('未查找到被访人部门信息')
            this.$forceUpdate()
          } else {
            this.model.visiteddeptfullname = res.data.result.result[0].deptfullname
            this.$forceUpdate()
          }
        }
      )
    },
    createmore() {
      if (this.$route.params.itemid !== '' && this.$route.params.itemid !== undefined) {
        var data = {
          qry_id: this.$route.params.itemid
        }
        var that = this
        getAction('/vtp/toaEnterParkApply/list', data).then(res => {
          if (res.data.success) {
            let entity = res.data.result.dataList[0]
            that.model.visitedname = entity.visitedname
            that.model.visitedphonenum = entity.visitedphonenum
            that.model.visitorname = entity.visitorname
            that.model.visitorphonenum = entity.visitorphonenum
            that.model.visitoridcard = entity.visitoridcard
            that.model.visitorcompony = entity.visitorcompony
            that.model.visitreason = entity.visitreason
            that.model.visiteddeptfullname = entity.visiteddeptfullname
            that.model.carnumber = entity.carnumber
            this.$forceUpdate()
          }
        })
      }
    },
    showpopup(index) {
      if (index === 1) {
        if (!this.show) {
          this.show = true
        } else {
          this.show = false
        }
      } else if (index === 2) {
        if (!this.show1) {
          this.show1 = true
        } else {
          this.show1 = false
        }
      } else {
        this.show = false
        this.show1 = false
      }
    },
    timeAction(time) {
      const intime = new Date().getTime()
      const date = new Date(time)
    //   var nTime = date - intime
      // 24小时内 86 400 000
    //   if (nTime < 86400000) {
    //     this.showCode = true
    //     this.showpopup(3)
    //   } else {
    //     this.showCode = false
    //   }
      this.showCode = false
      var seperator1 = '-'
      var seperator2 = ':'
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      var hour = date.getHours()
      if (hour.toString().length === 1) {
        hour = '0' + hour
      }
      var minutes = date.getMinutes()
      if (minutes.toString().length === 1) {
        minutes = '0' + minutes
      }
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      const a = date.getFullYear() + seperator1 + month + seperator1 + strDate + ' ' + hour + seperator2 + minutes
      this.model.estimateintoparktime = a
    },
    saveTimeAction(val) {
      this.show = false
      this.timeAction(Date.parse(val))
    },
    timeFormatterEnd(time) {
      const date = new Date(time)
      var seperator1 = '-'
      var seperator2 = ':'
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      var hour = date.getHours()
      var minutes = date.getMinutes()
      if (hour.toString().length === 1) {
        hour = '0' + hour
      }
      if (minutes.toString().length === 1) {
        minutes = '0' + minutes
      }
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      const a = date.getFullYear() + seperator1 + month + seperator1 + strDate + ' ' + hour + seperator2 + minutes
      this.model.estimateleavetime = a
    },
    saveTimeEnd(val) {
      this.show1 = false
      this.timeFormatterEnd(Date.parse(val)) // 选择时间日期 2019-01-30
    },
    addPartner() {
      let cope = {
        visitorname: '',
        visitorphonenum: '',
        visitoridcard: ''
      }
      this.lists.push(cope)
    },
    del(index) {
      this.lists.splice(index, 1)
    },
    beforeenpark() {
    //   if (this.showCode === true && uploadCount === 0) {
    //     Toast.fail('上传最新的健康码以及行程码截图')
    //     return false
    //   }
    //   if (uploadCount !== 0 && uploadCount < 2) {
    //     Toast.fail('请分别上传本人的健康码和行程码截图')
    //     return false
    //   }
    //   if (uploadCount !== 0 && uploadCount < 2 + 2 * this.lists.length) {
    //     Toast.fail('请分别上传所有人的健康码和行程码截图')
    //     return false
    //   }
      // 没有同行者信息
      if (this.lists.length === 0) {
        // 校验访客信息
        if (
          this.model.visitedname === '' ||
          this.model.visitedname === undefined ||
          this.model.visitedphonenum === '' ||
          this.model.visitedphonenum === undefined ||
          this.model.visitorname === '' ||
          this.model.visitorname === undefined ||
          this.model.visitorphonenum === '' ||
          this.model.visitorphonenum === undefined ||
          this.model.visitoridcard === '' ||
          this.model.visitoridcard === undefined ||
          this.model.visitorcompony === '' ||
          this.model.visitorcompony === undefined ||
          this.model.estimateintoparktime === '' ||
          this.model.estimateintoparktime === undefined ||
          this.model.estimateleavetime === '' ||
          this.model.estimateleavetime === undefined ||
          this.model.visitreason === '' ||
          this.model.visitreason === undefined
        ) {
          Toast.fail('请完善您的申请信息')
          return false
        }
        if (this.model.visitedphonenum.length !== 10 && this.model.visitedphonenum.length !== 11) {
          Toast.fail('被访人的电话位数不对，请核对')
          return false
        }
        if (this.model.visitorphonenum.length !== 10 && this.model.visitorphonenum.length !== 11) {
          Toast.fail('访客的电话位数不对，请核对')
          return false
        }
        if (this.model.visitoridcard.trim().length !== 15 && this.model.visitoridcard.trim().length !== 18) {
          Toast.fail('访客的身份证位数不对，请核对')
          return false
        }
        if (this.model.visitoridcard.length === 15) {
          var n = Number(this.model.visitoridcard)
          if (isNaN(n)) {
            Toast.fail('访客的身份证信息包含非数字，请核对')
            return false
          }
        }
        if (this.model.visitoridcard.length === 18) {
          var jieqv = this.model.visitoridcard.slice(0, 17)
          var m = Number(jieqv)
          if (isNaN(m)) {
            Toast.fail('访客的身份证信息包含非数字，请核对')
            return false
          }
          var a = this.model.visitoridcard.slice(-1)
          if (this.model.visitoridcard.slice(-1) !== 'X' && isNaN(a)) {
            Toast.fail('访客的身份证信息包含非数字，请核对')
            return false
          }
        }
        if (this.model.iscarry === '1' && this.model.productname === '') {
          Toast.fail('请填写产品明细')
          return false
        }
        return true
        // 有同行者信息
      } else {
        // 校验同行者信息
        for (var i = 0; i < this.lists.length; i++) {
          if (
            this.lists[i].visitorname === '' ||
            this.lists[i].visitorname === undefined ||
            this.lists[i].visitorphonenum === '' ||
            this.lists[i].visitorphonenum === undefined ||
            this.lists[i].visitoridcard === '' ||
            this.lists[i].visitoridcard === undefined
          ) {
            Toast.fail('请完善同行者的申请信息')
            return false
          }
          if (this.lists[i].visitorphonenum.length !== 10 && this.lists[i].visitorphonenum.length !== 11) {
            Toast.fail('同行者的电话位数不对，请核对')
            return false
          }
          if (this.lists[i].visitoridcard.trim().length !== 15 && this.lists[i].visitoridcard.trim().length !== 18) {
            Toast.fail('同行者的身份证位数不对，请核对')
            return false
          }
          if (this.lists[i].visitoridcard.length === 15) {
            var r = Number(this.lists[i].visitoridcard)
            if (isNaN(r)) {
              Toast.fail('同行者的身份证信息包含非数字，请核对')
              return false
            }
          }
          if (this.lists[i].visitoridcard.length === 18) {
            var w = this.lists[i].visitoridcard.slice(0, 17)
            var u = Number(w)
            if (isNaN(u)) {
              Toast.fail('同行者的身份证信息包含非数字，请核对')
              return false
            }
            var o = Number(this.model.visitoridcard.slice(-1))
            if (this.model.visitoridcard.slice(-1) !== 'X' && isNaN(o)) {
              Toast.fail('同行者的身份证信息包含非数字，请核对')
              return false
            }
          }
        }
        // 校验访客信息
        if (
          this.model.visitedname === '' ||
          this.model.visitedname === undefined ||
          this.model.visitedphonenum === '' ||
          this.model.visitedphonenum === undefined ||
          this.model.visitorname === '' ||
          this.model.visitorname === undefined ||
          this.model.visitorphonenum === '' ||
          this.model.visitorphonenum === undefined ||
          this.model.visitoridcard === '' ||
          this.model.visitoridcard === undefined ||
          this.model.visitorcompony === '' ||
          this.model.visitorcompony === undefined ||
          this.model.estimateintoparktime === '' ||
          this.model.estimateintoparktime === undefined ||
          this.model.estimateleavetime === '' ||
          this.model.estimateleavetime === undefined ||
          this.model.visitreason === '' ||
          this.model.visitreason === undefined
        ) {
          Toast.fail('请完善您的申请信息')
          return false
        }
        if (this.model.visitedphonenum.length !== 10 && this.model.visitedphonenum.length !== 11) {
          Toast.fail('被访人的电话位数不对，请核对')
          return false
        }
        if (this.model.visitorphonenum.length !== 10 && this.model.visitorphonenum.length !== 11) {
          Toast.fail('访客的电话位数不对，请核对')
          return false
        }
        if (this.model.visitoridcard.trim().length !== 15 && this.model.visitoridcard.trim().length !== 18) {
          Toast.fail('访客的身份证位数不对，请核对')
          return false
        }
        if (this.model.visitoridcard.length === 15) {
          var y = Number(this.model.visitoridcard)
          if (isNaN(y)) {
            Toast.fail('访客的身份证信息包含非数字，请核对')
            return false
          }
        }
        if (this.model.visitoridcard.length === 18) {
          var q = this.model.visitoridcard.slice(0, 17)
          var t = Number(q)
          if (isNaN(t)) {
            Toast.fail('访客的身份证信息包含非数字，请核对')
            return false
          }
          var p = this.model.visitoridcard.slice(-1)
          if (this.model.visitoridcard.slice(-1) !== 'X' && isNaN(p)) {
            Toast.fail('访客的身份证信息包含非数字，请核对')
            return false
          }
        }
        if (this.model.iscarry === '1' && this.model.productname === '') {
          Toast.fail('请填写产品明细')
          return false
        }
        return true
      }
    },
    enterpark(model) {
      if (this.sourceid !== null && this.sourceid !== undefined) {
        this.model.id = this.sourceid
        this.model.docno = this.docno
      }
      if (!this.beforeenpark()) {
        return
      }
      var loading = this.$weui.loading('处理中，请稍侯。')
      this.model.partner = this.lists
      let c = this.lists
      postAction('/vtp/toaEnterParkApply/enterpark', this.model)
        .then(res => {
          if (res.data.success) {
            Toast.success('申请成功')
            loading.hide()
            this.$router.push({
              name: 'history',
              params: {}
            })
            // if (uploadCount === 0) {
            //   this.$weui.confirm(
            //     '温馨提示：入园前24小时，需要上传您与同行人员的健康码和行程码；如14天内途径疫情中、高风险区，还需上传核酸检测报告，请注意查收消息推送，感谢您的配合！',
            //     {
            //       title: '申请已提交',
            //       buttons: [
            //         {
            //           label: '确定',
            //           type: 'primary',
            //           onClick: function() {}
            //         }
            //       ]
            //     }
            //   )
            // }
          } else {
            loading.hide()
            if (res.data.message) {
              Toast.fail(res.data.message)
            } else {
              Toast.fail('申请失败')
            }
          }
        })
        .catch(err => {
          loading.hide()
        })
    },
    isCarry(name) {
      if (name === '1') {
        this.showProduct = true
        this.model.productname = ''
      } else {
        this.showProduct = false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#app .weui-cells_form span >>> .van-button {
  height: 100%;
}
weui-cells .link-top {
  width: 100%;
  height: 1px;
  border-top: solid #acc0d8 1px;
}
.bannercontainner {
  padding: 15px;
}
.gonggao {
  flex: 1;
  background-color: rgb(252, 104, 72);
  border-radius: 15px;
  height: 35px;
  line-height: 35px;
}
.banner {
  background-image: url('../assets/banner.jpg');
  background-size: 100% 100%;
}
.greeBack {
  background-color: green;
}
#app .weui-loading_toast >>> .weui-mask_transparent {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: #666666;
  opacity: 0.5;
}
.weui-mask_transparent {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
.gonggaocontent {
  flex: 4;
  height: 35px;
  text-align: left;
  line-height: 35px;
  text-indent: 15px;
}
.line {
  margin-top: 5px;
  background-color: rgb(246, 246, 246);
  height: 2px;
}
.linecontainer {
  padding-left: 10px;
  padding-right: 10px;
}
.enterParkApplyleftcontent {
  background-image: url('../assets/enterParkApply.jpg');
  background-size: 100% 100%;
  border-radius: 15px;
}
.allfunction {
  padding-top: 20px;
}
.enterParkApplyrightcontent1 {
  background-image: url('../assets/applyHistory.jpg');
  background-size: 100% 100%;
  margin-top: 10px;
  border-radius: 15px;
}
.enterParkApplyrightcontent2 {
  background-image: url('../assets/cancelApply.jpg');
  background-size: 100% 100%;
  margin-top: 10px;
  border-radius: 15px;
}
.enterParkApplycontainer {
  padding: 10px;
}
.enterParkApplyrightcontainer {
  padding-left: 0px;
  padding-right: 10px;
  padding-top: 0px;
}

#app div >>> .weui-cells::before {
  border: 0px;
}
#app div >>> .weui-cells::after {
  border: 0px;
}
#app div >>> .weui-cells {
  margin-top: 0px;
}
.lineHeng {
  margin-left: 5%;
  width: 90%;
  padding: 0px;
  border-top: 1px solid var(--weui-FG-3);
}
.TitleClass {
  background: #e7eaec;
  margin: 0 auto;
  height: 30px;
  padding-top: 10px;
}

.radio-iscarry {
  display: inline-flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Edit.vue